module.exports = "/_next/static/images/strategicPlanningTraining-7fdd200504a1ab34bf09208905d9806b.webp";